<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Stocks from "@/components/modals/stocks.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { transform } from "lodash";

export default {
  page: {
    title: "Stocks"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    Stocks,
    UploadPopover,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Stocks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Stocks",
          active: true
        }
      ],
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      cycle: this.$store.state.data.cycle,
      campusId: this.$store.state.data.selectedCampus.id,
      deliveryUnitId: this.$store.state.data.selectedDU.id,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      form: {
        campusId: null,
        deliveryUnitId: null,
        status: "DRAFT",
        requisitionNumber: "",
        requisitionItems: []
      },
      transaction: {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      },
      tableBusy: false,
      uploadOptions: {
        type: "Transaction",
        placement: "lefttop",
        folder: "Stocks"
      },
      tabIndex: 0
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.referenceNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.referenceNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.deliveryUnit &&
            item.deliveryUnit.name
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.deliveryUnit.name
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.credit.toString().includes(this.filter.toUpperCase())
          ) {
            return item.credit.toString().includes(this.filter.toUpperCase());
          }
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(campus) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = campus.id;
      this.deliveryUnitId = this.$store.state.data.selectedDU.officeId;
      if (this.tabIndex == 0) this.getDraftTransactions();
      else this.getPostedTransactions();
    },
    changeDU(du) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = du.campusId;
      this.deliveryUnitId = du.officeId;
      if (this.tabIndex == 0) this.getDraftTransactions();
      else this.getPostedTransactions();
    },
    changeCycle(cycle) {
      this.cycle = cycle;
      this.campusId = this.$store.state.data.selectedDU.campusId;
      this.deliveryUnitId = this.$store.state.data.selectedDU.officeId;
      if (this.tabIndex == 0) this.getDraftTransactions();
      else this.getPostedTransactions();
    },
    getDraftTransactions() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetDraftStockTransactionByDu", this.deliveryUnitId)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.tableData = res.data.reverse();
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting transactions!",
            "error"
          );
        });
    },
    getPendingTransactions() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetPendingStockTransactionByDu", this.deliveryUnitId)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.tableData = res.data.reverse();
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting transactions!",
            "error"
          );
        });
    },
    getPostedTransactions() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetApprovedStockTransactionByDu", this.deliveryUnitId)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.tableData = res.data.reverse();
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting transactions!",
            "error"
          );
        });
    },
    generateRISNumber() {
      this.$store
        .dispatch("stock/GenerateStockTransactionRISNumber", {
          cycle: this.cycle,
          campusId: this.campusId
        })
        .then((res) => {
          return res.data;
        });
    },
    async onCreateRequisition() {
      this.submitted = true;
      if (
        this.form.requisitionItems.length == 0
      ) {
        this.showToast("No stock selected.", "warning");
        return;
      }
      if (
        this.checkForm(this.form.requisitionItems)
      ) {
        return;
      }
        this.form.requisitionItems.forEach((item) => {
          item.quantity = parseFloat(this.getExactAmt(item.quantity));
        });
        this.$store
          .dispatch("requisition/CreateRequisition", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.showToast("Successfully created request!", "success");
            this.$bvModal.hide("modal-requisition");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Creating Requisition!",
              "error"
            );
          });
      this.submitted = false;
    },
    createRequisition() {
      this.onReset();
      this.form.campusId = this.campusId;
      this.form.deliveryUnitId = this.deliveryUnitId;
      this.modalTitle = "Create Request";
      this.$bvModal.show("modal-requisition");
    },
    async updateRequisition(props) {
      this.onReset();
      this.form = cloneDeep(props);
      var transactions;
      await this.$store
        .dispatch("stock/GetStockTransactions", props.stockItemId)
        .then((res) => {
          transactions = res.data;
        });
      this.transaction.maxQuantity = this.runningBalance(transactions);
      this.modalTitle = "Update Request";
      this.$bvModal.show("modal-requisition");
    },
    onAddTransaction() {
      this.submitted = true;
      if (this.checkForm([this.transaction])) {
        return;
      }
      let transaction = cloneDeep(this.transaction);
      this.form.requisitionItems.push(transaction);
      this.$bvModal.hide("modal-transaction");
      this.$bvModal.show("modal-requisition");
      this.submitted = false;
    },
    addTransaction() {
      this.submitted = false;
      this.transaction = {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      };
      this.$bvModal.hide("modal-requisition");
      this.$bvModal.show("modal-transaction");
    },
    removeTransaction(index) {
      this.form.requisitionItems.splice(index, 1);
    },
    closeTransaction() {
      this.$bvModal.hide("modal-transaction");
      this.$bvModal.show("modal-requisition");
    },
    postTransaction(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this transaction.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/PostStockTransaction", props.id)
            .then(() => {
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully Posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Posted!", "error");
            });
        }
      });
    },
    deleteTransaction(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStockTransaction", props.id)
            .then((res) => {
              var transIndex = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(transIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    checkForm(form) {
      let error = false;
      form.forEach((transaction) => {
        if (
          transaction.quantity === "" ||
          transaction.quantity === null ||
          transaction.stockItemId === "" ||
          transaction.stockItemId === null
        ) {
          error = true;
        }
      });
      return error;
    },
    onReset() {
      this.form = {
        campusId: null,
        deliveryUnitId: null,
        status: "DRAFT",
        requisitionNumber: "",
        requisitionItems: []
      };
      this.transaction = {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      };
      this.submitted = false;
    },
    getStocks() {
      this.$refs.stocks.getData(true);
      this.$bvModal.show("stocks-modal");
    },
    async dropStocks(data) {
      await this.$store
        .dispatch("stock/GetStockTransactions", data.id)
        .then((res) => {
          data.transactions = res.data;
        });
      this.transaction.maxQuantity = this.runningBalance(data.transactions);
      this.transaction.stockItemId = data.id;
      this.transaction.stockItem = data.name;
    },
    runningBalance(data) {
      let balance = 0;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == "POSTED") {
            balance += data[i].debit - data[i].credit;
          }
        }
      }
      return balance;
    },
    checkCredit(transaction) {
      if (
        parseFloat(transaction.quantity) > parseFloat(transaction.maxQuantity)
      )
        transaction.quantity = transaction.maxQuantity.toString();
    },
    getAttachments(row) {
      row.viewFile = true;
      row.stockFiles = [];
      row.attachmentLoading = true;
      this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type
        })
        .then((res) => {
          row.attachmentLoading = false;
          row.stockFiles = res.data;
        })
        .catch(() => {
          row.attachmentLoading = false;
          this.showToast("Something went wrong! - getting documents", "error");
        });
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(id, transactionId, stockId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let transactionIndex = this.tableData.findIndex(
                (item) => item.id == transactionId
              );
              let fileIndex = this.tableData[
                transactionIndex
              ].stockFiles.findIndex((item) => item.id == id);
              this.tableData[transactionIndex].stockFiles.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    uploadedFiles() {}
  }
};
</script>

<template>
  <Layout
    @changeCampus="changeCampus"
    @changeDU="changeDU"
    @changeCycle="changeCycle"
  >
    <PageHeader :title="title" :items="items" />
    <!-- Create/Update Transaction -->
    <b-modal
      id="modal-requisition"
      :title="modalTitle"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onCreateRequisition"
        class="needs-validation"
        ref="fcForm"
      >
        <div>
          <div class="d-flex align-items-center justify-content-between">
            <div><h5 class="mt-2 mb-0">Stock Item</h5></div>
            <div>
              <button
                type="button"
                @click="addTransaction()"
                class="btn btn-sm btn-primary d-flex align-items-center ms-1"
              >
                <i class="bx bx-plus fs-6 me-1"></i>Add Stock
              </button>
            </div>
          </div>

          <hr />
          <div v-if="form.requisitionItems.length == 0">
            <div class="p-3 d-flex align-items-center justify-content-center">
              <span class="text-warning m-0">Add an item for transfer.</span>
            </div>
            <hr />
          </div>
          <div v-else>
            <div
              v-for="(item, index) in form.requisitionItems"
              :key="index"
              class="mb-3"
            >
              <div
                class="d-flex align-items-center justify-content-between px-2"
              >
                <div>
                  {{ item.stockItem }}
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <masked-input
                      id="credit"
                      type="text"
                      v-model="item.quantity"
                      placeholder="Enter Quantity..."
                      class="form-control form-control-sm"
                      :class="{
                        'is-invalid':
                          submitted &&
                          (item.quantity == null || item.quantity == '')
                      }"
                      autocomplete="off"
                      :mask="quantityMask"
                      @input="checkCredit(item)"
                    ></masked-input>
                  </div>
                  <div class="ms-5">
                    <i
                      @click="removeTransaction(index)"
                      class="cursor-pointer bx bx-trash text-danger font-size-18"
                    ></i>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>

        <div class="d-flex flex-row-reverse">
          <button class="btn btn-primary mt-3" type="submit">
            {{ form.id > 0 ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Add Transaction -->
    <b-modal
      id="modal-transaction"
      title="Add Stock"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      @close="closeTransaction"
    >
      <form
        @submit.prevent="onAddTransaction"
        class="needs-validation"
        ref="fcForm"
      >
        <div class="mb-3">
          <label for="stockId">Stock </label>
          <b-input-group>
            <template #append>
              <b-button @click="getStocks" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Stock..."
              class="form-control"
              :class="{
                'is-invalid': submitted && transaction.stockItemId == null
              }"
              v-model="transaction.stockItem"
            />
          </b-input-group>
          <div
            v-if="submitted && transaction.stockItemId == null"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="credit"
            ><div>Quantity</div>
            <!-- <small>Max Quantity: {{ transaction.maxQuantity }}</small> -->
          </label>
          <masked-input
            v-if="transaction.maxQuantity && transaction.maxQuantity > 0"
            id="credit"
            type="text"
            v-model="transaction.quantity"
            placeholder="Enter Quantity..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            }"
            autocomplete="off"
            :mask="quantityMask"
            @input="checkCredit(transaction)"
          ></masked-input>
          <input
            v-else
            id="credit"
            type="text"
            v-model="transaction.quantity"
            placeholder="Enter Quantity..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            }"
            disabled
            autocomplete="off"
          />
          <div
            v-if="
              submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>

        <div class="d-flex flex-row-reverse mb-3">
          <button class="btn btn-primary mt-3" type="submit">
            Add
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <b-tabs
      content-class="pt-3 pb-3 text-muted"
      v-model="tabIndex"
      nav-class="nav-tabs-custom"
    >
      <!-- Draft -->
      <b-tab
        @click="
          getDraftTransactions();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Draft</span>
        </template>
        <div v-if="tabIndex == 0" class="card-body p-0">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0">List of Draft Requests</h5>
            <div class="d-flex">
              <button
                type="button"
                @click="createRequisition()"
                class="btn btn-sm btn-primary d-flex align-items-center ms-1"
              >
                <i class="bx bx-plus fs-6 me-1"></i>Create Request
              </button>
            </div>
          </div>
          <div class="d-flex flex-row-reverse mb-2">
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Request..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <b-card v-if="tableBusy">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="filtered.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no
              requests matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requests
              available
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="text-muted m-0" style="min-width: 85%">
                    Transaction
                  </h6>
                  <h6 class="text-muted text-center m-0" style="min-width: 15%">
                    Actions
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3"
                style="min-width: fit-content"
                :style="`z-index: ${filtered.length - index + 10}`"
              >
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    :keyId="`draft-${x.id}`"
                    v-if="$store.state.decrypt.isAdmin()"
                  />
                </div>
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="text-muted" style="min-width: 85%">
                      <small>RIS No. {{ x.referenceNumber }}</small>
                      <div class="text-white">
                        <span class="text-info">{{ x.credit }}</span> -
                        {{ x.stockItem.name }}
                      </div>
                      <div>{{ x.description }}</div>
                    </div>
                    <div
                      class="d-flex justify-content-center"
                      style="min-width: 15%"
                    >
                      <a
                        href="javascript:void(0);"
                        class="text-success me-1"
                        @click="postTransaction(x)"
                        ><i class="bx bx-check-circle font-size-20 fs-2"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="text-info me-1"
                        @click="updateRequisition(x)"
                        ><i class="bx bx-edit-alt font-size-20 fs-2"></i
                      ></a>
                      <a
                        href="javascript:void(0);"
                        class="text-danger"
                        @click="deleteTransaction(x)"
                        ><i class="bx bx-trash font-size-20 fs-2"></i
                      ></a>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing
              {{ (currentPage - 1) * perPage + 1 }}
              -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab
        @click="
          getPendingTransactions();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-check-circle-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Pending</span>
        </template>
        <div v-if="tabIndex == 1" class="card-body p-0">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="mb-0">List of Pending Requests</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Request..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <b-card v-if="tableBusy">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="filtered.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no
              requests matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requests
              available
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="text-muted m-0" style="min-width: 70%">
                    Transaction
                  </h6>
                  <h6 class="text-muted m-0" style="min-width: 30%">
                    Attachments
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3"
                style="min-width: fit-content"
                :style="`z-index: ${filtered.length - index + 10}`"
              >
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    :keyId="`pending-${x.id}`"
                    v-if="$store.state.decrypt.isAdmin()"
                  />
                </div>
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="text-muted" style="min-width: 70%">
                      <small>RIS No. {{ x.referenceNumber }}</small>
                      <div class="text-white">
                        <span class="text-info">{{ x.credit }}</span> -
                        {{ x.stockItem.name }}
                      </div>
                      <div>{{ x.description }}</div>
                    </div>
                    <div class="text-muted" style="min-width: 30%">
                      <div>
                        <span class="me-1">Attachments:</span>
                        <a
                          href="javascript:void(0);"
                          @click="getAttachments(x)"
                          :id="`pending-viewFiles-${x.id}`"
                          >[Show attachments]</a
                        >
                        <b-popover
                          :target="`pending-viewFiles-${x.id}`"
                          triggers="click"
                          placement="right"
                          :show.sync="x.viewFile"
                          custom-class="popover-supplier"
                        >
                          <template v-slot:title>
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <small>Attachments</small>
                              <span
                                class="bx bx-x font-size-14 cursor-pointer"
                                @click="x.viewFile = false"
                              ></span>
                            </div>
                          </template>
                          <table
                            class="table table-bordered"
                            v-if="
                              !x.attachmentLoading && x.stockFiles.length > 0
                            "
                          >
                            <thead>
                              <tr>
                                <th>File Description</th>
                                <th style="width: 30px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="attachments in x.stockFiles"
                                :key="attachments.id"
                              >
                                <td
                                  @click="openDocument(y)"
                                  class="hoverable-link cursor-pointer"
                                >
                                  <div>
                                    {{ attachments.description }}
                                  </div>
                                  <small>{{
                                    formatDateWithTime(
                                      new Date(attachments.dateTimeUploaded)
                                    )
                                  }}</small>
                                </td>
                                <td>
                                  <i
                                    v-if="
                                      isAdmin ||
                                        attachments.applicationUserId ==
                                          token.ApplicationUserId
                                    "
                                    @click="removeFile(attachments.id, x.id)"
                                    class="cursor-pointer bx bx-trash text-danger"
                                  ></i>
                                  <i v-else class="bx bx-trash text-muted"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            class="text-center"
                            v-if="
                              !x.attachmentLoading && x.stockFiles.length == 0
                            "
                          >
                            No data found
                          </div>
                          <div v-if="x.attachmentLoading" class="text-center">
                            <b-spinner
                              variant="primary"
                              label="Loading..."
                            ></b-spinner>
                          </div>
                        </b-popover>
                      </div>
                      <div class="mt-1">
                        <button
                          :id="`pending-document${x.id}`"
                          type="button"
                          class="btn btn-sm btn-outline-success"
                          @click="x.addDocu = true"
                        >
                          <i class="bx bx-plus"></i>Add Attachments
                        </button>
                        <upload-popover
                          :option="uploadOptions"
                          :sourceId="x.id"
                          @uploaded="uploadedFiles"
                          :showPV="x.addDocu"
                          @closePopover="x.addDocu = false"
                          :dzId="`dropzone-pending${x.id}`"
                          :pvId="`pending-document${x.id}`"
                        ></upload-popover>
                      </div>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing
              {{ (currentPage - 1) * perPage + 1 }}
              -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab
        @click="
          getPostedTransactions();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-check-circle-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Posted</span>
        </template>
        <div v-if="tabIndex == 2" class="card-body p-0">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="mb-0">List of Posted Requests</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Request..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <b-card v-if="tableBusy">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="filtered.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no
              requests matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requests
              available
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="text-muted m-0" style="min-width: 70%">
                    Transaction
                  </h6>
                  <h6 class="text-muted m-0" style="min-width: 30%">
                    Attachments
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3"
                style="min-width: fit-content"
                :style="`z-index: ${filtered.length - index + 10}`"
              >
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    :keyId="`posted-${x.id}`"
                    v-if="$store.state.decrypt.isAdmin()"
                  />
                </div>
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="text-muted" style="min-width: 70%">
                      <small>RIS No. {{ x.referenceNumber }}</small>
                      <div class="text-white">
                        <span class="text-info">{{ x.credit }}</span> -
                        {{ x.stockItem.name }}
                      </div>
                      <div>{{ x.description }}</div>
                    </div>
                    <div class="text-muted" style="min-width: 30%">
                      <div>
                        <span class="me-1">Attachments:</span>
                        <a
                          href="javascript:void(0);"
                          @click="getAttachments(x)"
                          :id="`posted-viewFiles-${x.id}`"
                          >[Show attachments]</a
                        >
                        <b-popover
                          :target="`posted-viewFiles-${x.id}`"
                          triggers="click"
                          placement="right"
                          :show.sync="x.viewFile"
                          custom-class="popover-supplier"
                        >
                          <template v-slot:title>
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <small>Attachments</small>
                              <span
                                class="bx bx-x font-size-14 cursor-pointer"
                                @click="x.viewFile = false"
                              ></span>
                            </div>
                          </template>
                          <table
                            class="table table-bordered"
                            v-if="
                              !x.attachmentLoading && x.stockFiles.length > 0
                            "
                          >
                            <thead>
                              <tr>
                                <th>File Description</th>
                                <th style="width: 30px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="attachments in x.stockFiles"
                                :key="attachments.id"
                              >
                                <td
                                  @click="openDocument(y)"
                                  class="hoverable-link cursor-pointer"
                                >
                                  <div>
                                    {{ attachments.description }}
                                  </div>
                                  <small>{{
                                    formatDateWithTime(
                                      new Date(attachments.dateTimeUploaded)
                                    )
                                  }}</small>
                                </td>
                                <td>
                                  <i
                                    v-if="
                                      isAdmin ||
                                        attachments.applicationUserId ==
                                          token.ApplicationUserId
                                    "
                                    @click="removeFile(attachments.id, x.id)"
                                    class="cursor-pointer bx bx-trash text-danger"
                                  ></i>
                                  <i v-else class="bx bx-trash text-muted"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            class="text-center"
                            v-if="
                              !x.attachmentLoading && x.stockFiles.length == 0
                            "
                          >
                            No data found
                          </div>
                          <div v-if="x.attachmentLoading" class="text-center">
                            <b-spinner
                              variant="primary"
                              label="Loading..."
                            ></b-spinner>
                          </div>
                        </b-popover>
                      </div>
                      <div class="mt-1">
                        <button
                          :id="`posted-document${x.id}`"
                          type="button"
                          class="btn btn-sm btn-outline-success"
                          @click="x.addDocu = true"
                        >
                          <i class="bx bx-plus"></i>Add Attachments
                        </button>
                        <upload-popover
                          :option="uploadOptions"
                          :sourceId="x.id"
                          @uploaded="uploadedFiles"
                          :showPV="x.addDocu"
                          @closePopover="x.addDocu = false"
                          :dzId="`dropzone-posted${x.id}`"
                          :pvId="`posted-document${x.id}`"
                        ></upload-popover>
                      </div>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing
              {{ (currentPage - 1) * perPage + 1 }}
              -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <Stocks ref="stocks" @dropData="dropStocks($event)"></Stocks>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
.transactionTable tr th {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
